import moment from "moment";
import { cx } from "shared/utils";

export const DateTimeTableCell = ({
  value,
  className = ""
}: {
  value?: string | Date | null;
  className?: string;
  // eslint-disable-next-line sonarjs/function-return-type -- that's ReactNode. We can use it here
}) => {
  const date = value && moment(value).isValid() ? moment(value) : "";

  if (!date) return "--";

  return (
    <p className={cx("space-y-2", className)}>
      <time
        dateTime={date.format("YYYY-MM-DD")}
        className="text-sm font-medium text-content-1000 block"
      >
        {date.format("MMM D, YYYY")}
      </time>
      <time
        dateTime={date.format("HH:mm")}
        className="text-xs text-content-400 block"
      >
        {date.format("h:mm A")}
      </time>
    </p>
  );
};
